/**
 *
 */
export class Resource {

    constructor(url) {
        this.url = url;
        this.listeners = new Map();
        this.data = new Map();
    }

    /**
     *
     * @param url
     * @param params
     * @returns {Promise<{then: then}>}
     */
    static async fetchCollection(url, params) {
        let response = await axios.get(url, {
            params: params
        });
        return Promise.resolve(response.data);
    }

}
